import * as P from 'prop-types';
import { AddressProps } from '@redux/reducers/NewOrderReducer/PropTypes';

export const propTypes = {
  $state: P.shape({
    step: P.number.isRequired,
    cpf: P.string,
    collectAddress: P.shape(AddressProps).isRequired,
    deliveryAddress: P.shape(AddressProps).isRequired,
  }).isRequired,
  $actions: P.shape({
    setStep: P.func.isRequired,
    setCollect: P.func.isRequired,
    setCustomer: P.func.isRequired,
    setDelivery: P.func.isRequired,
    calculateTotalBudgetAmount: P.func.isRequired,
  }).isRequired,
};

export const defaultProps = {};

export default {
  propTypes,
  defaultProps,
};
